import styles from './NewsList.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { NewsCardProps, UI_NewsCard } from 'ui/components/2-molecules/Card/NewsCard/NewsCard';
import { UI_LinkWithIcon } from 'ui/components/1-atoms/Action/LinkWithIcon/LinkWithIcon';
import IconArrow from 'ui/icons/icon_right_arrow.svg';

export interface NewsListProps {
	heading: string;
	link?: { url: string; target?: string; name: string };
	items: NewsCardProps[];
}
export const UI_NewsList = ({ heading, link, items }: NewsListProps) => {
	return (
		<div className={styles.NewsList}>
			<UI_Heading className={styles.NewsList_heading} headingLevel="h2" style="lg50">
				{heading}
			</UI_Heading>
			{link?.url && (
				<UI_LinkWithIcon
					className={styles.NewsList_link}
					url={link.url}
					target={link.target}
					icon={
						<span className={styles.NewsList_linkIcon}>
							<IconArrow />
						</span>
					}
					text={link.name}
				/>
			)}
			<div className={styles.NewsList_items}>
				{items?.map((item, index) => <UI_NewsCard className={styles.NewsList_card} key={index} {...item} />)}
			</div>
		</div>
	);
};
